import React from 'react';
import { Text, TextMessage } from 'components/tt-forms/common';

class TruongPhongGiaoViecView extends React.Component {

  render() {
    return (
      <div>
        <div className="items-form mb5">
          <div className="row pr15 pl15">
            <Text
              className="col-input"
              label="Công chức xử lý:"
              value={this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh ?
                this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh.ten : ''} />
          </div>
        </div>

        <div className="items-form">
          <div className="row pr15 pl15">
            <TextMessage
              className="col-12"
              value={this.props.thongTinXuLyGiaiQuyet.yKienXuLy || ''}
              label='Ý kiến xử lý:' />
          </div>
        </div>
      </div>
    )
  }
}

export default TruongPhongGiaoViecView;


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-xu-ly/truong-phong/TruongPhongGiaoViecView.jsx